<template>
  <van-overlay z-index="99" :show="show">
    <div class="overlay-wrapper" @click.stop>
      <div class="block">
        <!--文本为：提示-->
        <h3 class="title">提示</h3>
        <!--文本为： 为了您更好的高效体验，拍照前请确认旧机是否  已撕膜（前后膜）,若未撕膜拍照上传将会驳回补充拍照影响时效。 -->
        <!-- <div class="content">
          Nhằm giúp bạn có trả nghiệm tốt hơn, trước khi chụp xin xác nhận máy cũ đã
          <span class="bold">xé màng (trước sau) hay chưa</span>
          , nếu chưa xé màng mà tải ảnh lên thì sẽ bị từ chối, phải bổ sung ảnh và sẽ ảnh hưởng đến thời hiệu
        </div> -->
        <div class="content">请告知客户去除贴模/钢化贴模来检查划痕，屏幕质量并给出准确评估结果。</div>
        <div class="footer">
          <!--文本为：是的，我已确认-->
          <van-button type="info" @click="confirmTip">是的，我已确认</van-button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name:'photoOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmTip(){
      this.$emit('comfirm')
    }
  }
};
</script>

<style lang="less" scoped>
.overlay-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 560px;
  /*height: 170px;*/
  min-height: 340px;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  .title {
    line-height: 40px;
    padding: 40px 40px 20px;
    font-size: 30px;
    color: #000;
    font-weight: 600;
    text-align: center;
    margin: 0;
  }
  .content {
    font-size: 26px;
    padding: 0 30px 40px;
    color: #666;
    margin: 0;
    line-height: 1.5;
    text-align: center;
    .bold {
      font-weight: 600;
    }
  }
  .footer {
    & /deep/ .van-button--normal {
      width: 100%;
    }
    & /deep/ .van-button {
      border-radius: 0;
    }
    & /deep/ .van-button--info {
      color: var(--theme-color);
      background: #f7f8fa;
      border: none;
      display: block;
    }
  }
}
</style>
